import React from 'react';
import cx from 'classnames';
import logoImage from './img/logo-3d.png.js';
import maskSmall from './img/mask-sm.png.js';
import maskBottom from './img/mask-bottom-new.png.js';
import styles from './index.module.scss.js';

const Logo = ({
  size = "md",
  logo,
  className,
  style,
  onClick,
  text = {
    coin: "Housebets coin",
    soon: "Coming soon"
  }
}) => /* @__PURE__ */ React.createElement(
  "button",
  {
    type: "button",
    "aria-label": "Home",
    className: cx(styles.box, className, {
      [styles[size]]: !!size
    }),
    style,
    onClick,
    "data-logo": true
  },
  logo ? /* @__PURE__ */ React.createElement("img", { className: styles.logo, src: logo, alt: "" }) : /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["logo-image"],
      src: logoImage,
      width: 38,
      height: 40,
      alt: "Logo"
    }
  ),
  size === "md" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles["mask-bottom"],
      src: maskBottom,
      alt: "mask bottom"
    }
  ), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.title }, text.coin, " ", /* @__PURE__ */ React.createElement("span", null, "(HBTS)")), /* @__PURE__ */ React.createElement("div", { className: styles["coming-soon"] }, /* @__PURE__ */ React.createElement("span", null, text.soon)))) : /* @__PURE__ */ React.createElement("img", { className: styles["mask-small"], src: maskSmall, alt: "mask small" })
);
Logo.displayName = "Layout.Logo";

export { Logo };
//# sourceMappingURL=index.js.map
